import Swal from 'sweetalert2';

window.submitForm = function submitForm(url, method, action, formData, type, update, notify_time = 5000, isCalendar = false) {
    $('form button[type="submit"]').attr('disabled', 'true');

    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        processData: false,
        contentType: false,
        data: formData,
        success: function (data) {
            $('.ajaxFormError').remove();
            if (data.status === true || data.status === 'true') {
                if (data.update !== false) {
                    console.log(isCalendar);
                    if (type === 'comment') {
                        $("#commentsModal").animate({scrollTop: $('#commentsModal').height()}, 1000);
                    }
                    if (isCalendar === true) {
                        //window.appointments.fullCalendar('refetchEvents');
                        $('#edit-appointment').modal('hide');
                    } else {
                        $('#' + data.update).html(data.html);
                    }
                }
                if (data.update2 !== false) {
                    console.log(isCalendar);
                    if (isCalendar === true) {
                        //window.appointments.fullCalendar('refetchEvents');
                        $('#edit-appointment').modal('hide');
                    } else {
                        $('#' + data.update2).html(data.html2);
                    }
                }
                if (data.modal !== false) {
                    $('body #' + data.modal).modal('show');
                }
                if (data.update3 !== false) {
                    console.log(isCalendar);
                    if (isCalendar === true) {
                        //window.appointments.fullCalendar('refetchEvents');
                        $('#edit-appointment').modal('hide');
                    } else {
                        $('#' + data.update3).html(data.html3);
                    }
                }
                if (data.scroll !== false && data.scroll) {
                    $('html, body').animate({
                        scrollTop: $('#' + data.scroll).offset().top
                    });
                }
                window.formNotify(action, data.status, type, notify_time);
                if (data.redirect) {
                    setTimeout(function () {
                        if (data.redirect !== '') {
                            window.location.href = data.redirect;
                        } else if (data.redirect === 'refresh') {
                            location.reload();
                        }
                    }, notify_time);
                } else {
                    $('form button[type="submit"]').removeAttr('disabled');
                }
                if (data.datatable && data.datatable !== '') {
                    $('#' + data.datatable).DataTable().ajax.reload();
                }
                if (data.datatable2 && data.datatable2 !== '') {
                    $('#' + data.datatable2).DataTable().ajax.reload();
                }
            } else {
                window.formNotify(action, false, type, notify_time);
                $('form button[type="submit"]').removeAttr('disabled');
            }
            if (data.status === true) {
                $('.modal').modal('hide');
            }

            $('.ajax button').removeAttr('disabled');
        },
        error: function (err) {
            $('.ajaxFormError').remove();

            let title = '';
            let description = '';

            if (err.status == 422) { // when status code is 422, it's a validation issue

                $('#success_message').fadeIn().html(err.responseJSON.message);
                // display errors on each form field
                $.each(err.responseJSON.errors, function (i, error) {
                    let el = $(document).find('[name="' + i + '"]');
                    if (el.length === 0) {
                        el = $(document).find('[name="' + i + '[]"]');
                    }
                    el.after($('<div class="ajaxFormError alert alert-danger mt-2"><span class="svg-icon svg-icon-danger svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="black"/><rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="black"/><rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="black"/></svg></span><div class="d-flex flex-column"><h4 class="mb-1 text-dark">' + window.language['base']['alert'] + '</h4><span>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</span></div></div>'));
                });
            } else if (err.status === 413) {
                title = 'Erro [413]';
                description = 'Ficheiro demasiado grande.';
            }


            $('.ajax button').removeAttr('disabled');

            if (title.length > 0) {
                generalNotification(
                    'error',
                    title,
                    description,
                    null
                );
            }
        },
        complete: function () {
            $('.ajax button').removeAttr('disabled');
        }
    });
}

window.swalFormAction = function swalFormAction(action, type, url, method, formData, update, notifyTime = 2500, hasCalendar = false) {
    if (action === 'update' || action === 'delete') {
        status = 'warning';

        let notificationParams = window.getNotifyParams(action, status, type);
        Swal.fire({
            icon: 'warning',
            title: notificationParams.title,
            text: notificationParams.description,
            showCancelButton: true,
            showCloseButton: false,
            confirmButtonText: notificationParams.button,
            cancelButtonText: notificationParams.cancel
        }).then((result) => {
            if (result.isConfirmed) {
                submitForm(url, method, action, formData, type, update, notifyTime, hasCalendar);
            } else {
                $('.ajax button').removeAttr('disabled');
            }
        });
    } else {
        submitForm(url, method, action, formData, type, update, notifyTime, hasCalendar);
    }
}

$('body').on('submit', '.ajax', function (e) {
    e.preventDefault();

    $(this).find('button').prop('disabled', true);

    let url = $(this).attr('action');
    let method = $(this).attr('method');
    let action = $(this).attr('data-action');
    let type = $(this).attr('data-type');
    let update = $(this).attr('data-update');
    let formData = new FormData($(this).get(0));
    $('.signature').each(function () {
        formData.append($(this).attr('data-name'), getSignatureData($(this).attr('id')));
    });
    let hasCalendar = $(this).attr('data-calendar') === 'true';
    swalFormAction(action, type, url, method, formData, update, 2500, hasCalendar);
});

window.getNotifyParams = function getNotifyParams(type, status, page_type) {
    let notifyObj = $('#notificationData');

    console.log(type, status);
    if (status === true || status === 'true') {
        status = 'success';
    }
    if (status === false || status === 'false') {
        status = 'error';
    }

    let notifyParams = {
        title: "<h4 class='mb-1 text-dark'>" + window.language[page_type]['notifications'][type][status]['title'] + "</h4>",
        description: window.language[page_type]['notifications'][type][status]['description'],
        button: window.language[page_type]['notifications'][type][status]['button'] ?? '',
        cancel: window.language['base']['cancel']
    };

    if (status === 'success') {
        notifyParams.icon = 'las la-check-circle';
        notifyParams.type = 'success';
    } else {
        notifyParams.icon = 'las la-exclamation-circle';
        notifyParams.type = 'danger';
    }

    return notifyParams;
}

window.generalNotification = function generalNotification(type, title, description, button, notifyTime = 5000) {
    let notifyParams = {
        title: "<h4 class='mb-1 text-dark'>" + title + "</h4>",
        description: description,
        button: button ?? '',
        cancel: window.language['base']['cancel']
    };

    if (type === 'success') {
        notifyParams.icon = 'las la-check-circle';
        notifyParams.type = 'success';
    } else {
        notifyParams.icon = 'las la-exclamation-circle';
        notifyParams.type = 'danger';
    }

    $.notify({
        icon: notifyParams.icon,
        title: notifyParams.title,
        message: notifyParams.description
    }, {
        element: 'body',
        type: notifyParams.type,
        animate: {
            enter: 'animated flipInY',
            exit: 'animated flipOutY'
        },
        placement: {
            from: 'bottom',
            align: 'right'
        },
        delay: notifyTime
    });

    return notifyParams;
}

window.formNotify = function formNotify(type, status, page_type, notify_time = 5000) {
    if (status !== false) {
        status = 'success';
    }
    let params = getNotifyParams(type, status, page_type);

    $.notify({
        icon: params.icon,
        title: params.title,
        message: params.description
    }, {
        element: 'body',
        type: params.type,
        animate: {
            enter: 'animated flipInY',
            exit: 'animated flipOutY'
        },
        placement: {
            from: 'bottom',
            align: 'right'
        },
        delay: notify_time
    });
}

$('body').on('click', '.modal_close_btn', function () {
    $('body .modal').modal('hide');
});
